import { Button } from '@heroui/react';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import { ExitDialog } from 'components';
import { useDialog } from '@/hooks';
import { useNavigate } from 'react-router';
import { LuArrowLeft } from 'react-icons/lu';

const MainMenuBackButtonComponent = () => {
    const { handleCancelar, handleOpenDialog, open } = useDialog();

    const navigate = useNavigate();
    const { isTouchDevice } = useIsTouchDevice();

    const handleMenuPrincipal = () => {
        navigate(`/`);
    };

    return (
        <>
            <Button
                startContent={
                    <LuArrowLeft />
                }
                color='default'
                onPress={handleOpenDialog}
                className={`
                    shadow-md
                    ${isTouchDevice
                        ? 'text-2xl'
                        : 'text-sm '
                    }
                `}
            >
                Menú principal
            </Button>

            <ExitDialog
                title="¿Está seguro que desea salir al menú principal?"
                subtitle="Los datos de esta encuesta se perderán."
                open={open}
                handleCancelar={handleCancelar}
                handleAceptar={handleMenuPrincipal}
            />
        </>
    );
};

export default MainMenuBackButtonComponent;
